import * as React from "react";
import { Dialog, Classes, Button, Intent } from "./externals";
export class FormDialog extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleAcceptDialog = () => {
            this.props.onAccept(this.state.content);
            this.closeDialog();
        };
        this.closeDialog = () => {
            this.props.onClose();
        };
        this.updateContent = (content) => {
            this.setState({ content });
        };
        this.state = {
            content: props.defaultContent,
        };
    }
    render() {
        const { icon, text, isDialogOpen } = this.props;
        const { content } = this.state;
        return (React.createElement(Dialog, { className: "scheduleDialog", icon: icon, title: text, isOpen: isDialogOpen, usePortal: process.env.NODE_ENV !== "test", onClose: this.closeDialog },
            React.createElement("div", { className: Classes.DIALOG_BODY }, this.props.form({ onUpdate: this.updateContent, content })),
            React.createElement("div", { className: Classes.DIALOG_FOOTER },
                React.createElement("div", { className: Classes.DIALOG_FOOTER_ACTIONS },
                    React.createElement(Button, { onClick: this.closeDialog }, "Cancel"),
                    React.createElement(Button, { intent: Intent.PRIMARY, onClick: () => this.handleAcceptDialog() }, "Accept")))));
    }
}
//# sourceMappingURL=FormDialog.js.map